import {useState} from 'react';

import {EnnablLogger} from 'utils/ennabl';
import {urlDownload, urlDownloadWithName} from 'utils/misc';

/**
 * Downloads a remote file under the given name, exposing the in-flight state.
 * Falls back to a plain download when the file can't be fetched — the file is still downloaded,
 * but keeps the name from the `Content-Disposition` header.
 */
export const useUrlDownload = () => {
  const [downloading, setDownloading] = useState(false);

  const download = async (url: string, name: string) => {
    setDownloading(true);

    try {
      await urlDownloadWithName(url, name);
    } catch (err) {
      EnnablLogger.captureException(err instanceof Error ? err : new Error(String(err)));
      urlDownload(url, name);
    } finally {
      setDownloading(false);
    }
  };

  return {downloading, download};
};
